import React, { useEffect, useState } from "react";
import { findOne } from "../../services/Client__Service";
import { getfile } from "../../services/Document__Servive";

const CardClient = ({ clientId = 0, initialClient = null }) => {
  const [client, setClient] = useState(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (clientId !== 0) {
      fetchOneClient(clientId);
    }
  }, [clientId]);

  useEffect(() => {
    if (initialClient) {
      setClient({ ...initialClient });
      fecthFile(initialClient.logo);
    }
  }, [initialClient]);

  const fetchOneClient = async (idParams) => {
    findOne(idParams)
      .then((response) => {
        setClient(response.data);
        fecthFile(response.data.logo);
      })
      .catch(() => {
        setClient(null);
      });
  };

  const fecthFile = async (logo) => {
    getfile(logo, "image")
      .then((response) => {
        setImage(response.data);
      })
      .catch(() => {
        setImage(null);
      });
  };

  return (
    client && (
      <div className="card-client">
        <div>
          {image && (
            <img
              src={URL.createObjectURL(image)}
              alt="image"
              className="image"
            />
          )}
          <div className="primary-info">
            <div>
              <p className="nom">
                {client.nom.length <= 20
                  ? client.nom
                  : client.nom.substring(0, 19) + "..."}
              </p>
              <p className="sigle">{client.sigle}</p>
            </div>
            <p className={`statut ${client.statut == 0 && "inactif"}`}>
              {client.statut == 0 ? "inactif" : "Actif"}
            </p>
          </div>
        </div>
        <div className="secondary-info">
          <p>
            <strong>Tél : </strong> {client.tel1}
          </p>
          <p>
            <strong>Ville : </strong> {client.ville}
          </p>
          <p>
            <strong>Forme Juridique : </strong> {client.formeJuridique}
          </p>
          <p>
            <strong>Email : </strong> {client.email1}
          </p>
        </div>
      </div>
    )
  );
};

export default CardClient;
